// src/admin/pages/AdminOverviewPage.jsx
//
// Superadmin overview ("vedi come tenant"): pick a tenant from the dropdown and
// render that tenant's dashboard via the shared DashboardView. This is the
// per-tenant deep-dive surface — a cross-tenant aggregate would need a BE
// group_by=tenant endpoint (or a per-tenant fan-out) and is a separate step.
//
// Reuses the SA tenant-dropdown pattern from RunListPage (adminListTenants → t.id),
// with per-user localStorage persistence of the last-viewed tenant.
//
import React, { useState, useEffect } from 'react';
import { DashboardView } from '../../sections/Dashboard.jsx';
import { adminListTenants } from '../adminApi.js';
import { useAuth } from '../../auth/AuthContext.jsx';

const FONT = "'DM Sans', sans-serif";

export default function AdminOverviewPage() {
  const { user } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [selected, setSelected] = useState('');

  const storageKey = `admin_overview_tenant:${user?.user_id || user?.email || 'anon'}`;

  useEffect(() => {
    adminListTenants()
      .then((list) => {
        const rows = Array.isArray(list) ? list : [];
        setTenants(rows);
        // Hydrate from last-viewed tenant only if it still exists.
        try {
          const last = localStorage.getItem(storageKey);
          if (last && rows.some(t => t.id === last)) setSelected(last);
        } catch { /* private mode */ }
      })
      .catch(() => setTenants([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onPick(id) {
    setSelected(id);
    try {
      if (id) localStorage.setItem(storageKey, id);
      else localStorage.removeItem(storageKey);
    } catch { /* private mode */ }
  }

  const selectedName = tenants.find(t => t.id === selected)?.display_name || '';

  const header = (
    <>
      <h1 style={{ fontSize: '22px', fontWeight: 700, marginBottom: 4, fontFamily: FONT }}>Panoramica</h1>
      <p style={{ color: '#6c6c6d', fontSize: '13px', margin: '0 0 16px', fontFamily: FONT }}>
        Visualizza la dashboard di un singolo tenant{selectedName ? ` — ${selectedName}` : ''}
      </p>
      <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, fontFamily: FONT }}>
        <label style={{ fontSize: 13, color: '#3a3a3c' }}>Tenant:</label>
        <select
          value={selected}
          onChange={e => onPick(e.target.value)}
          style={{
            padding: '6px 10px', borderRadius: 6,
            border: '1px solid rgba(0,0,0,0.12)', background: '#fff',
            fontSize: 13, fontFamily: FONT, minWidth: 240,
          }}
        >
          <option value="">— Seleziona —</option>
          {tenants.map(t => (
            <option key={t.id} value={t.id}>{t.display_name || t.id}</option>
          ))}
        </select>
      </div>
    </>
  );

  return (
    <DashboardView
      tenantId={selected || undefined}
      isSuperadmin
      headerSlot={header}
    />
  );
}
